import { render, staticRenderFns } from "./DemandesFinalisees.vue?vue&type=template&id=6b9bb27f&"
import script from "./DemandesFinalisees.vue?vue&type=script&lang=js&"
export * from "./DemandesFinalisees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports